// extracted by mini-css-extract-plugin
module.exports = {"footer":"_4190"};